import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Box, Button, ButtonGroup, CardContent, Card,
    Grid2 as Grid,
    Typography,
    CardHeader,
    LinearProgress,
} from '@mui/material';
import { Add, Cancel, CleanHands, Delete, Edit, Message, PlayArrow } from '@mui/icons-material';
//import { delete_user, get_current_user_live, get_user_list, set_current_user, } from "../db/user";
import { getSelectedElement, propComparator } from "../utils/ui_utils";
import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { UserDialog } from "../modals/UserDialog";
import { get_user_list } from "../FirebaseUtils/dbUser";



export default function UserPage() {
    const dialogRef = useRef()
    const dialogParsingRef = useRef()
    const childRefDelete = useRef()
    const [element_list, setElementList] = useState([])
    const [cur_user, setCurrentUser] = useState()
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true)

    const handleNew = () => {
        dialogRef.current.onNew()
    }


    const reloadFn = async () => {
        setIsLoading(true)
        const data = await get_user_list()
        console.log("DATA", data)
        setIsLoading(false)

        setElementList(data.sort(propComparator('username')))

    }

    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const handleDelete = (r, i) => {
        const cb = () => {
    //        delete_user(r.id)
        }
        childRefDelete.current.confirmDelete('Cancella utente', `sei sicuro di voler cancellare l'utente:<br/> <b>${r.username}</b>`, cb)
    }


    useEffect(() => {
        document.title = 'ShowtimeAnafibj - Gestione utenti';
        reloadFn()
/*         const initData = async () => {
            const data = await get_user_list()
            setElementList(data.sort(propComparator('username')))
            const s_id = searchParams.get('s_id')
            if (s_id && s_id !== undefined) {
                const s = getSelectedElement(s_id, data, 'id')
                if (s && s.id) {
                    handleParsing(s, -1, cur_user?.id === s_id)
                } else {
                    setSearchParams({})
                }
            }
        } */
//        initData()
    }, [])




    return (
        <Box sx={{ textAlign: 'center', mt: 1 }}>
            <UserDialog ref={dialogRef} reloadFn={reloadFn} />

            <DeleteconfirmationSection ref={childRefDelete} />
            <Card sx={{ border: '1px solid lightblue' }}>
                <CardContent>
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={2} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                           Gestione utenti 
                        </Grid>
                        <Grid size={"grow"} sx={{ textAlign: 'right' }}>
                        </Grid>

                    </Grid>
                    <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                        <Grid size="grow">
                            Id
                        </Grid>
                        <Grid size="grow">
                            Nome visualizzato
                        </Grid>
                        <Grid size="grow">
                            Email
                        </Grid>
                        <Grid size="grow">
                            Ruolo
                        </Grid>
                        <Grid size={2} sx={{ textAlign: 'right' }}>
                            <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>Nuovo utente </Button>
                        </Grid>
                    </Grid>
                    <Grid >
                {isLoading ?
                    <LinearProgress />
                    :
                    <>
                        {element_list.map((s, k) => (
                            <OneUser is_current={cur_user?.id === s.id} key={k} user={s} index={k} handleEdit={handleEdit}  handleDelete={handleDelete} />
                        ))}
                        </>}
                    </Grid>
                </CardContent>
            </Card>

        </Box>
    );
}



const OneUser = ({ user, index, handleDelete, handleEdit,  }) => {



    return (
        <Grid container sx={{ borderTop: '1px solid black', pt: 1, mt: 1 }}>
            <Grid size={"grow"} sx={{ fontSize: '0.7em' }}>
                {user.uid}
            </Grid>
            <Grid size={"grow"}>
                {user.displayName}
            </Grid>
            <Grid size={"grow"}>
                {user.email}
            </Grid>
            <Grid size={"grow"}>
                {user.role}
            </Grid>
            <Grid size="auto">
                <ButtonGroup size="small">
                    <Button color="warning" onClick={() => handleEdit(user, index)} startIcon={<Edit />}></Button>
                    <Button color="error" onClick={() => handleDelete(user, index)} startIcon={<Delete />}></Button>
                </ButtonGroup>

            </Grid>
        </Grid>

    )
}